import { Box, BoxProps } from '@chakra-ui/react';
import { ReactNode } from 'react';

type FooterProps = {
  children: ReactNode;
} & BoxProps;

export const Footer = ({ children, ...rest }: FooterProps) => {
  return (
    <Box as="footer" {...rest}>
      {children}
    </Box>
  );
};
